// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__x7eUP","dense":"_type_dense__1jKfK","right":"_type_right__2d2mx"};